import src from "IMAGE";
export default { src, width: 2000, height: 200, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mNgEpDTYBOU02TklVBk4BaVYeARl2fgEZNj4BaRBtEAJb0CNgQabccAAAAASUVORK5CYII="};
